import ValidationError from "./ValidationError.js"

export default class FormValidationError extends ValidationError {
	constructor(field, message) {
		super(message);
		this.field = field;
	}
}
